module.exports = __webpack_public_path__ + "img/8B.336c77c6.jpg";